import { Link as RouterLink } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import HandymanIcon from "@mui/icons-material/Handyman";

function Logo() {
  return (
    <Button
      color="inherit"
      startIcon={<HandymanIcon />}
      component={RouterLink}
      to="/"
    >
      <Typography>MyTools</Typography>
    </Button>
  );
}

export default Logo;
